import React from 'react';
import { Route } from 'react-router-dom';

import Dashboard from '../components/Dashboard/TraderDashboard/Dashboard';
import LiveMarketPage from '../components/Dashboard/TraderDashboard/LiveMarketPage';
import UserDirectoryDashboardPage from '../components/Dashboard/TraderDashboard/UserDirectoryDashboardPage';
import UserProfilePage from '../components/Dashboard/TraderDashboard/UserProfilePage';



const dashboardRoutes = [
  <Route key="dashboard" path="/dashboard" element={<Dashboard />} />,
  <Route key="live-market" path="/dashboard/live-market" element={<LiveMarketPage />} />,
  <Route key="live-chart" path="/dashboard/live-chart/full" element={<LiveMarketPage />} />,
  <Route key="directory" path="/dashboard/directory" element={<UserDirectoryDashboardPage />} />,
  <Route key="user-profile" path="/dashboard/user/:id" element={<UserProfilePage />} />,
];

export default dashboardRoutes;
